import React, { useState, useEffect } from "react";
import { get, remove } from "../../../constants/apiRoutes";
import Swal from "sweetalert2";
import Table from "../TableComponents/Table";
import RecipientForm from "../FormComponents/RecipientForm";
import UserRegisterForm from "../FormComponents/UserRegisterForm";

const UserAndEmail = () => {
  const recipientsTableheading = ["S.no", "Name", "Email"];
  const userAndEmailTableHeading = ["S.no", "Email", "Role"];

  const [recipients, setRecipients] = useState([]);
  const [recipientToEdit, setRecipientToEdit] = useState(null);

  const [usersAndEmail, setUsersAndEmail] = useState([]);
  const [usersAndEmailToEdit, setUsersAndEmailToEdit] = useState(null);

  const [error, setError] = useState("");

  useEffect(() => {
    fetchRecipients();
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const result = await get("Account/users");
      setUsersAndEmail(result);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const fetchRecipients = async () => {
    try {
      const result = await get("Account/recipients");
      setRecipients(result);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const handleEditRecipient = (recipient) => {
    fetchRecipients();
    setRecipientToEdit(recipient);
  };

  const handleDeleteRecipient = async (id) => {
    const { value: confirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (confirmed) {
      try {
        await remove(`Account/recipients/${id}`);
        fetchRecipients();
        Swal.fire({
          icon: "success",
          title: "user removed",
          // text: 'Silahkan Cek Email Kamu, Buat Verifikasi!',
          showConfirmButton: false,
          timer: 2500,
        });
      } catch (error) {
        console.error("Error deleting recipient", error);
        setError("Failed to delete recipient");
      }
    }
  };

  const handleEditUsers = (usersData) => {
    fetchUsers();
    setUsersAndEmailToEdit(usersData);
  };

  const handleDeleteUsers = async (id) => {
    const { value: confirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (confirmed) {
      try {
        await remove(`Account/users/${id}`);
        fetchUsers();
        Swal.fire({
          icon: "success",
          title: "User Removed Sucessfully",
          // text: 'Silahkan Cek Email Kamu, Buat Verifikasi!',
          showConfirmButton: false,
          timer: 2500,
        });
      } catch (error) {
        console.error("Error deleting recipient", error);
        setError("Failed to delete recipient");
      }
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-content px-20 py-5">
        <div className="flex gap-8 mb-14 h-full">
          <div className="w-full">
            <RecipientForm
              editData={recipientToEdit}
              fetchRecipients={fetchRecipients}
            />
          </div>

          <div className="w-full  ">
            <UserRegisterForm
              editData={usersAndEmailToEdit}
              fetchUsersData={fetchUsers}
              resetEditData={setUsersAndEmailToEdit}
            />
          </div>
        </div>

        <section className="flex flex-row w-full">
          <div className="w-1/2 m-2">
            <Table
              title={"Recipient List"}
              headings={recipientsTableheading}
              data={recipients}
              onEdit={handleEditRecipient}
              onDelete={handleDeleteRecipient}
              error={error}
            />
          </div>
          <div className="w-1/2 m-2">
            <Table
              title={"User Availability"}
              headings={userAndEmailTableHeading}
              data={usersAndEmail}
              onEdit={handleEditUsers}
              onDelete={handleDeleteUsers}
              error={error}
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default UserAndEmail;
